// src/components/Contact.js
import React, { useEffect, useState } from 'react';

const Contact = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const contactInfo = {
    phoneNumbers: [
      { number: "+91 9046373358", label: "Aizops Pvt Ltd", icon: "📞" },
    
    ],
    email: "support@aizops.com",
    address: {
      city: "City Centre, Matigara, Siliguri, Dist- Darjeeling,",
      state: "West Bengal",
      zip: "734001",
      country: "India"
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-white">
      {/* Hero Section */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="text-center">
          <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 mb-3 transition-all duration-500 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
            <span className="mr-2">🏨</span>
            Housekeeping Management
          </div>
          <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-3 transition-all duration-500 delay-100 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
            Get in <span className="text-blue-600">Touch</span>
          </h1>
          <p className={`text-lg text-gray-600 max-w-2xl mx-auto transition-all duration-500 delay-200 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
            We're here to help with all your housekeeping management needs
          </p>
        </div>
      </div>

      {/* Contact Cards Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          
          {/* Phone Card */}
          <div className={`group relative transition-all duration-700 delay-300 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {/* Animated Circle Background */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-200 rounded-full opacity-30 animate-pulse group-hover:scale-150 transition-all duration-500"></div>
            <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-blue-300 rounded-full opacity-20 animate-pulse delay-700 group-hover:scale-125 transition-all duration-500"></div>
            
            {/* Card */}
            <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-blue-100 hover:shadow-xl transition-all hover:-translate-y-2">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mb-4">
                <span className="text-2xl">📞</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Phone Numbers</h3>
              <div className="space-y-3">
                {contactInfo.phoneNumbers.map((phone, index) => (
                  <div key={index} className="border-b border-blue-50 pb-2 last:border-0">
                    <p className="text-xs text-gray-500">{phone.label}</p>
                    <p className="text-sm font-semibold text-gray-800 hover:text-blue-600 transition-colors">{phone.number}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Email Card */}
          <div className={`group relative transition-all duration-700 delay-500 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {/* Animated Circle Background */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-200 rounded-full opacity-30 animate-pulse delay-500 group-hover:scale-150 transition-all duration-500"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-blue-300 rounded-full opacity-20 animate-pulse delay-1000 group-hover:scale-125 transition-all duration-500"></div>
            
            {/* Card */}
            <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-blue-100 hover:shadow-xl transition-all hover:-translate-y-2">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mb-4">
                <span className="text-2xl">📧</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Email Address</h3>
              <div className="space-y-2">
                <p className="text-xs text-gray-500">General Inquiries</p>
                <p className="text-sm font-semibold text-gray-800 hover:text-blue-600 transition-colors break-all">
                  {contactInfo.email}
                </p>
              </div>
            </div>
          </div>

          {/* Address Card */}
          <div className={`group relative transition-all duration-700 delay-700 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {/* Animated Circle Background */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-blue-200 rounded-full opacity-30 animate-pulse delay-1000 group-hover:scale-150 transition-all duration-500"></div>
            <div className="absolute -top-4 -left-4 w-20 h-20 bg-blue-300 rounded-full opacity-20 animate-pulse delay-1400 group-hover:scale-125 transition-all duration-500"></div>
            
            {/* Card */}
            <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-blue-100 hover:shadow-xl transition-all hover:-translate-y-2">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mb-4">
                <span className="text-2xl">📍</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Office Address</h3>
              <div className="space-y-1">
                <p className="text-sm text-gray-700">{contactInfo.address.street}</p>
                <p className="text-sm text-gray-700">
                  {contactInfo.address.city}, {contactInfo.address.state} {contactInfo.address.zip}
                </p>
                <p className="text-sm text-gray-700">{contactInfo.address.country}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Working Hours Banner */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className={`bg-gradient-to-r from-blue-50 to-white rounded-2xl p-6 text-center border border-blue-100 transition-all duration-700 delay-900 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-gray-600">Available Now</span>
          </div>
          <p className="text-gray-800">
            <span className="font-semibold">Working Hours:</span> Monday - Friday, 9:00 AM - 6:00 PM (EST)
          </p>
          <p className="text-sm text-gray-500 mt-2">24/7 emergency support available for urgent housekeeping issues</p>
        </div>
      </div> */}

      {/* Simple Map Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="bg-gradient-to-br from-blue-100 to-blue-200 rounded-2xl overflow-hidden shadow-lg h-64 relative flex items-center justify-center">
          <div className="text-center z-10">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg animate-bounce">
              <span className="text-2xl">🗺️</span>
            </div>
            <p className="text-gray-700 font-semibold">Housekeeping Headquarters</p>
            <p className="text-sm text-gray-600">Siliguri, West Bengal</p>
          </div>
          {/* Decorative circles */}
          <div className="absolute top-10 left-10 w-32 h-32 bg-blue-300/30 rounded-full animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-400/20 rounded-full animate-pulse delay-700"></div>
          <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-white/10 rounded-full animate-pulse delay-1000"></div>
        </div>
      </div>

     
      {/* Floating Chat Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button className="w-14 h-14 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform duration-300 group">
          <span className="text-2xl">💬</span>
          <span className="absolute right-16 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-800 text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
            Chat with us
          </span>
        </button>
      </div>
    </div>
  );
};

export default Contact;